import moment from "moment";
import "moment/locale/es";

moment.locale("es");

// Función auxiliar para obtener el texto del estado
const getEstadoTexto = (estadoNum) => {
  switch (estadoNum) {
    case 1:
      return "Vigente";
    case 0:
      return "Cancelada";
    default:
      return "Desconocido";
  }
};

const reporteTraspasoEntreAlmacenesPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;
  let filtrados = [];


  if (values.usuarios && values.usuarios.length > 0) {
    let textoFiltrado = "";
    values.usuarios.map((valueUsuario) => {
      textoFiltrado += `${valueUsuario.nombre} ${valueUsuario.apellidoPaterno} ${valueUsuario.apellidoMaterno}\n`;
      return null;
    });
    filtrados.push([
      { text: "Usuarios:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }


  if (values.proyectos && values.proyectos.length > 0) {
    let textoFiltrado = "";
    values.proyectos.map((valueProyecto) => {
      textoFiltrado += `${valueProyecto.nombre}\n`;
      return null;
    });
    filtrados.push([
      { text: "Proyectos:", style: "subheader" },
      { text: textoFiltrado, style: "textoChico" },
    ]);
  }


  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  let traspasos = [];
  const desglosar = values.desglosarProductos;
  
  let tableHeaders = [];
  let tableWidths = [];

  if (desglosar) {

    tableHeaders = [
      { text: "Folio/Clave", style: "tituloTabla" },
      { text: "Insumo/Fecha", style: "tituloTabla" },
      { text: "Familia", style: "tituloTabla" },
      { text: "Usuario", style: "tituloTabla" },
      { text: "Proyecto Origen", style: "tituloTabla" },
      { text: "Proyecto Destino", style: "tituloTabla" },
      { text: "Cant. Tras.", style: "tituloTabla" },
      { text: "Estado", style: "tituloTabla" },
    ];
    tableWidths = ["8%", "21%", "10%", "15%", "15%", "15%", "8%", "8%"];

    for (const tras of values.traspasos) {
      if (tras.esInsumo) {
        traspasos.push([
          { text: tras.clave || "N/A", style: "textoTabla", alignment: "left" },
          { text: (tras.descripcion || "N/A") + (tras.observaciones  ? ("\n" + tras.observaciones) : ""), style: "textoTabla", alignment: "left" },
          { text: tras.familia || "N/A", style: "textoTabla", alignment: "left" },
          { text: "", style: "textoTabla" }, 
          { text: "", style: "textoTabla" },
          { text: "", style: "textoTabla" }, 
          { text: tras.cantidadTraspasada, style: "textoTabla", alignment: "right" },
          { text: getEstadoTexto(tras.estado), style: "textoTabla", alignment: "left" },
        ]);
      } else {
        traspasos.push([
          { text: tras.folio, style: "textoTabla", bold: true, alignment: "left" },
          { text: tras.fecha, style: "textoTabla", bold: true, alignment: "left" }, // Usamos la columna de insumo para la fecha
          { text: "", style: "textoTabla" }, // Columna Familia vacía
          { text: tras.usuario, style: "textoTabla", bold: true, alignment: "left" },
          { text: tras.proyectoOrigen, style: "textoTabla", bold: true, alignment: "left" },
          { text: tras.proyectoDestino, style: "textoTabla", bold: true, alignment: "left" },
          { text: tras.cantidadTraspasada, style: "textoTabla", bold: true, alignment: "right" },
          { text: getEstadoTexto(tras.estado), style: "textoTabla", bold: true, alignment: "left" },
        ]);
      }
    }
  } else {
    tableHeaders = [
      { text: "Folio", style: "tituloTabla" },
      { text: "Fecha", style: "tituloTabla" },
      { text: "Usuario", style: "tituloTabla" },
      { text: "Proyecto Origen", style: "tituloTabla" },
      { text: "Proyecto Destino", style: "tituloTabla" },
      { text: "Cant. Sol.", style: "tituloTabla" },
      { text: "Estado", style: "tituloTabla" },
    ];
    tableWidths = ["6%", "12%", "12%", "25%", "25%", "10%", "10%"];

    for (const tras of values.traspasos) {
      traspasos.push([
        { text: tras.folio, style: "textoTabla", alignment: "left" },
        { text: tras.fecha, style: "textoTabla", alignment: "center" },
        { text: tras.usuario, style: "textoTabla", alignment: "left" },
        { text: tras.proyectoOrigen + (tras.observaciones ? ("\n" + tras.observaciones) : ""), style: "textoTabla", alignment: "left" },
        { text: tras.proyectoDestino, style: "textoTabla", alignment: "left" },
        { text: tras.cantidadTraspasada, style: "textoTabla", alignment: "right" },
        { text: getEstadoTexto(tras.estado), style: "textoTabla", alignment: "left" },
      ]);
    }
  }

  const totalInsumosTraspasados = values.totalInsumosTraspasados || 0;
  
  let totalsRow = [];

  if (desglosar) {
    totalsRow = [
      { text: "TOTAL:", style: "tituloTabla", alignment: "left", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: totalInsumosTraspasados, style: "textoTotal", bold: true, alignment: "right", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, true, true], fillColor: "#cccccc" },
    ];
  } else {
     totalsRow = [
      { text: "TOTAL:", style: "tituloTabla", alignment: "left", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, false, true], fillColor: "#cccccc" },
      { text: totalInsumosTraspasados, style: "textoTotal", bold: true, alignment: "right", border: [true, true, true, true], fillColor: "#cccccc" },
      { text: "", style: "textoTabla", border: [false, true, true, true], fillColor: "#cccccc" },
    ];
  }

  traspasos.push(totalsRow);


  // --- Definición del Documento PDF ---
  var dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      // Cabecera (Logo, Info Empresa, Título Reporte, Fechas)
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              {
                border: [false, false, false, false],
                image: "logo",
                fit: [80, 80],
              },
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [
                      {
                        text: empresa.persona
                          ? empresa.nombre
                          : empresa.nombre +
                            " " +
                            empresa.apellidoPaterno +
                            " " +
                            empresa.apellidoMaterno,
                        style: "tableHeader",
                      },
                    ],
                    [{ text: "R.F.C: " + empresa.rfc, style: "textoChico", alignment: "center" }],
                    [
                      {
                        text:
                          empresa.calle +
                          " " +
                          empresa.numeroCalle +
                          " " +
                          (empresa.numeroInterior ? empresa.numeroInterior : ""),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text:
                          empresa.colonia.tipoAsentamiento +
                          " " +
                          empresa.colonia.nombre +
                          " C.P. " +
                          empresa.colonia.cp +
                          " " +
                          empresa.municipio.nombre +
                          " " +
                          empresa.estado.abreviatura +
                          " " +
                          empresa.pais.abreviatura +
                          " ",
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [{ text: "REPORTE DE TRASPASOS ENTRE ALMACENES", style: "tableHeader" }], // <-- Título cambiado
                  ],
                },
                layout: "noBorders",
              },
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha Inicial:", style: "subheader", alignment: "center" }],
                    [{ text: moment(values.fechaInicial).locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha Final:", style: "subheader", alignment: "center" }],
                    [{ text: moment(values.fechaFinal).locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
                    [{ text: moment().locale("es").format("LL"), style: "textoChico", alignment: "center" }],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
      },
      // Tabla de Filtros
      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["20%", "80%"],
          body: filtrados, 
        },
        layout: {
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
      // Tabla Principal de Datos
      {
        style: "tableExample",
        table: {
          widths: tableWidths, 
          layout: {
            defaultBorder: true,
          },
          body: [
            tableHeaders,
            ...traspasos, 
          ],
        },
        layout: {
          fillColor: (rowIndex, node, columnIndex) => {
            if (rowIndex === node.table.body.length - 1) {
              return "#cccccc";
            }
            if (rowIndex === 0) {
              return "#cccccc";
            }
            return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
          },
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) { return 1; },
          hLineColor: function (i, node) { return "#adaaaa"; },
          vLineColor: function (i, node) { return "#adaaaa"; },
          hLineStyle: function (i, node) {
            if (i === 0 || i === node.table.body.length) { return null; }
            return { dash: { length: 2, space: 1 } };
          },
          vLineStyle: function (i, node) {
            if (i === 0 || i === node.table.widths.length) { return null; }
            return { dash: { length: 2 } };
          },
        },
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      header: {
        fontSize: 9,
        bold: true,
      },
      subheader: {
        fontSize: 8,
        bold: true,
      },
      tableExample: {
        margin: [0, 5, 0, 5],
      },
      tablaSinMargen: {
        margin: [0, 0, 0, 0],
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      textoChico: {
        fontSize: 8,
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      textoTabla: {
        fontSize: 8,
        italics: false,
      },
      textoTotal: {
        fontSize: 8, 
        bold: true,
        italics: false,
      },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
  };
  return dd;
};

export default reporteTraspasoEntreAlmacenesPdf;